<script setup>
import { computed } from 'vue';
import { resolveColourValue } from '@/Helpers/themeColourResolver';

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    brand: { type: Object, default: () => ({}) },
    shift: { type: Number, default: 0 },
});

function isLastOdd(index) {
    return index === props.row.content.items.length - 1 && props.row.content.items.length % 2 !== 0;
}

const bgHex = computed(() => resolveColourValue(props.row?.content?.bgColour, props.brand, props.shift));
const borderHex = computed(() => resolveColourValue(props.row?.content?.borderColour, props.brand, props.shift));
const statHex = computed(() => resolveColourValue(props.row?.content?.statColour, props.brand, props.shift));
const descriptionHex = computed(() => resolveColourValue(props.row?.content?.descriptionColour, props.brand, props.shift));
</script>

<template>
    <div v-if="row.content?.items" class="w-full p-fl-4">
        <div class="grid grid-cols-2 gap-3">
            <div
                v-for="(item, index) in row.content.items"
                :key="index"
                class="rounded-xl border p-4 flex flex-col justify-end"
                :class="{ 'col-span-2': isLastOdd(index) }"
                :style="{
                    backgroundColor: bgHex,
                    borderColor: borderHex,
                }"
            >
                <span
                    class="font-bold text-fl-xl leading-tight"
                    :style="{ color: statHex }"
                    v-text="item.stat"
                />
                <span
                    class="text-fl-sm leading-tight mt-1"
                    :style="{ color: descriptionHex }"
                    v-text="item.description"
                />
            </div>
        </div>
    </div>
</template>
